'use strict';
module.exports = [
  require('./bignumber'),
  require('./boolean'),
  require('./chain'),
  require('./complex'),
  require('./fraction'),
  require('./matrix'),
  require('./number'),
  require('./resultset'),
  require('./string'),
  require('./unit')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/index.js
// module id = 1332
// module chunks = 0